/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import type {
  FixedSizeCodec,
  FixedSizeDecoder,
  FixedSizeEncoder,
} from "@solana/kit";
import { combineCodec, getEnumDecoder, getEnumEncoder } from "@solana/kit";

export enum LockTypeLabel {
  Permanent = 0,
}

export type LockTypeLabelArgs = LockTypeLabel;

export function getLockTypeLabelEncoder(): FixedSizeEncoder<LockTypeLabelArgs> {
  return getEnumEncoder(LockTypeLabel);
}

export function getLockTypeLabelDecoder(): FixedSizeDecoder<LockTypeLabel> {
  return getEnumDecoder(LockTypeLabel);
}

export function getLockTypeLabelCodec(): FixedSizeCodec<
  LockTypeLabelArgs,
  LockTypeLabel
> {
  return combineCodec(getLockTypeLabelEncoder(), getLockTypeLabelDecoder());
}
